/* eslint-disable no-useless-escape */

const validationPatterns = {
  companyUid: '(^[a-zA-Z]+-[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}$)|(^[a-zA-Z]+-[0-9]{9}$)',
  email: '.@.',
  // TODO: Find proper url regex
  // url: '^([a-zA-Z][a-zA-Z+-.]*:)?(\/\/(.+@)?.+(:\d)?)', // (WIP)
  url: '',
  isoDate: '^\d\d(\d\d)?(-)?\d{1,2}(-)?\d{1,2}$',
  isoDateTime: '^\d\d(\d\d)?(-)?\d{1,2}(-)?\d{1,2}(T\d{1,2}(:)?\d{1,2}(:)?\d{1,2}(\.\d{1,3})?(Z|([+-]\d{1,2}(:)?(\d{1,2})?)?))?$',

  /** @deprecated Please use the ```isoDate``` pattern */
  date: '[0-9]{4}-[0-9]{2}-[0-9]{2}',
  /** @deprecated Please use the ```isoDateTime``` pattern */
  dateTime: '(\d\d\d\d)(-)?(\d\d)(-)?(\d\d)(T)?(\d\d)(:)?(\d\d)(:)?(\d\d)(\.\d+)?(Z|([+-])(\d\d)(:)?(\d\d))',
};

export default validationPatterns;
